import isAcquisitionSoftware from 'app/utils/isAcquisitionSoftware';

export default function getProjectNameFromEnv() {
  if (process.env.PLATFORM === 'website') return 'picoxia-web';
  if (isAcquisitionSoftware()) return 'picoxia-acquisition';
  return 'picoxia-interpretation';
}
